<template>
  <div>
    <script v-html="metaWebsite" type="application/ld+json"></script>
    <script v-html="metaOrganization" type="application/ld+json"></script>
     <nav class="" v-bind:class="{ noShrink : onScroll } && is_mobile_app == 1 ? '' : 'navbar fixed-top'">

      <div class="share-modal">
        <!-- <b-button v-b-modal.shareModal>Share Modal</b-button> -->

        <b-modal ref="shareModal" id="shareModal" hide-footer hide-header>
          <div class="share-modal-header">
            <img
              src="@/assets/img/share_Module_Header_mytiketi.jpg"
              class="img-fluid"
              alt="Refer A Friend"
            />
            <p class="share-header-text" style="color: #fff">
              REFER A
              <br />FRIEND
            </p>
            <button v-on:click="onCloseModal()" class="close-btn">
              &times;
            </button>
          </div>

          <div class="share-modal-body p-4">
            <div class="row align-items-center py-2">
              <div class="col-4">
                <img
                  src="@/assets/img/share-icon1.png"
                  class="img-fluid"
                  alt="Share"
                />
              </div>

              <div class="col-8">
                <p
                  class="mb-1 lg-text text-pink"
                  style="color: #fff !important"
                >
                  YOU GET
                </p>
                <p class="mb-1 lg-text" style="color: #fff">ONE FREE TICKET!</p>
                <P class="mb-0 n-text" style="color: #fff"
                  >once your friend complete 5 successful transactions on
                  Ticketak</P
                >
              </div>
            </div>

            <div class="row align-items-center py-2">
              <div class="col-8">
                <p class="mb-0 lg-text font-weight-normal" style="color: #fff">
                  Your Friend Get 10% discount on first 3 transaction.
                </p>
              </div>

              <div class="col-4">
                <img
                  src="@/assets/img/share-icon2.png"
                  class="img-fluid"
                  alt="Share"
                />
              </div>
            </div>

            <div class>
              <p
                class="text-center text-muted small-text"
                style="color: #fff !important"
              >
                Share your Referral link &amp; Code
                <router-link to class="text-pink" style="color: #fff !important"
                  >How Referral works?</router-link
                >
              </p>

              <div
                v-clipboard:copy="messageCopy"
                v-clipboard:success="onCopy"
                class="refrel-link"
                style="color: #fff !important"
              >
                {{ messageCopy }}
              </div>

              <ul
                style="justify-content: space-evenly"
                class="list-inline d-flex mb-0 pt-4"
              >
                <li class="d-md-none list-inline-item mr-0">
                  <a
                    :href="
                      'https://wa.me/?text=Share%20This%20referral%20code%20with%20your%20friend%20' +
                      messageCopy
                    "
                    target="_blank"
                  >
                    <img
                      src="@/assets/img/icons/whatsapp.png"
                      class="img-fluid"
                      alt="Whatsapp"
                      width="40"
                    />
                  </a>
                </li>
                <!-- <li class="list-inline-item mr-0">
                  <a href>
                    <img src="@/assets/img/icons/sms.png" class="img-fluid" width="40" />
                  </a>
                </li>-->
                <li class="list-inline-item mr-0">
                  <a
                    target="_blank"
                    :href="
                      'mailto:?subject=Ticketak Referral&body=' +
                      this.messageCopy
                    "
                  >
                    <img
                      src="@/assets/img/icons/email.png"
                      class="img-fluid"
                      alt="Email"
                      width="40"
                    />
                  </a>
                </li>
                <li class="list-inline-item mr-0">
                  <a
                    target="_blank"
                    :href="
                      'https://mail.google.com/mail/?view=cm&fs=1&to=&subject=Ticketak Referral&body=' +
                      this.messageCopy
                    "
                  >
                    <img
                      src="@/assets/img/icons/gmail.png"
                      class="img-fluid"
                      alt="Gmail"
                      width="40"
                    />
                  </a>
                </li>
                <li class="d-md-none list-inline-item mr-0">
                  <div v-on:click="onfbshare()">
                    <img
                      src="@/assets/img/icons/facebook.png"
                      class="img-fluid"
                      alt="Facebook"
                      width="40"
                    />
                  </div>
                </li>
                <li class="list-inline-item mr-0">
                  <div
                    ref="copy"
                    v-clipboard:copy="messageCopy"
                    v-clipboard:success="onCopy"
                  >
                    <img
                      src="@/assets/img/icons/copy.png"
                      alt="Copy"
                      style="cursor: pointer"
                      class="img-fluid"
                      width="40"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </b-modal>
      </div>

      <div class="container-fluid header-desktop">
        <!-- DESKTOP NAVIGATION BAR -->
        <div
          class="wrapper pt-0 d-none d-lg-block w-100"
          style="margin: 0px"
          :class="isRTL ? 'rtl' : ''"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <router-link :to="'/'">
                <img
                  v-on:click="onClickLogo()"
                  src="@/assets/img/Cineco-Logo.png"
                  class="nav-brand"
                  alt="Wanasa"
                />
               
                <!--  -->
              </router-link>
            </div>

            <div
              class="d-flex align-items-center justify-content-end"
              :style="isRTL ? 'gap:10px' : ''"
            >
              <!--Menu Links-->
              <div class="d-flex align-items-center justify-content-center">
                <div class="ml-lg-2">
                  <ul class="list-inline mb-0">
                    <li
                      v-for="(menu, menuKey) in allLanguageDataMenu"
                      :key="menuKey"
                      class="list-inline-item mr-0"
                    >
                      <router-link
                        v-if="menu.path == '/'"
                        :class="menu.path == '/' ? 'd-none' : ''"
                        @click.native="onClickHome()"
                        to
                        class="nav-link px-1 px-lg-2"
                      >
                        {{ $t(menu.name) }}</router-link
                      >
                      <router-link
                        v-else
                        :to="menu.path"
                        class="nav-link px-1 px-lg-2"
                        :class="
                          navbarMenu($route.path, menu.path)
                            ? 'my_tick_nav'
                            : 'nav_hover'
                        "
                      >
                        {{ $t(menu.name) }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- some -->

              <div class="jm-search">
                <input
                  type="search"
                  :class="
                    project == 'ticketak'
                      ? 'jm-search-ticketak'
                      : 'jm-search-mytiketi'
                  "
                  required
                  :placeholder="$t('SEARCH_MOVIES_CINEMAS')"
                  v-on:keyup="searchData()"
                  v-on:focusout="onFocusOut()"
                  v-model="searchValue"
                />
                <!-- <span class="search-close">&times;</span> -->
                <div
                  v-if="
                    movieListSearch.length > 0 || cinemaListSearch.length > 0
                  "
                  class="search-results"
                >
                  <ul class="list-unstyled mb-0">
                    <span class="ml-1 text-grey">Movies</span>
                    <li
                      v-on:click="movieListSearch = []"
                      v-for="(movie, movieListIndex) in movieListSearch"
                      :key="movieListIndex"
                    >
                    <!-- <a class="text-dark" :href="$router.resolve({
                          name: 'movie',
                          params: {
                            movieID: movie.Value,
                            cinemaID: '0',
                            props: { selectedFilter, cat_id: movie.CategoryID },
                          },
                        }).href">{{ movie.Label }}</a> -->
                    
                      <router-link
                        class="text-dark"
                        :to="{
                          name: 'movie',
                          params: {
                            movieID: movie.Value,
                            cinemaID: '0',
                            props: { selectedFilter, cat_id: movie.CategoryID },
                            attr: 'search'
                          },
                        }"
                        >{{ movie.Label }}</router-link
                      >
                    </li>
                    <!-- <div class="seprator"></div>
                    <span class="ml-1 text-grey">Cinemas</span>
                    <li
                      v-on:click="cinemaListSearch = []"
                      v-for="(cinema, cinemaListIndex) in cinemaListSearch"
                      :key="cinemaListIndex"
                    >
                      <router-link
                        class="text-dark"
                        :to="{
                          name: 'cinemaDetails',
                          params: { cinemaId: cinema.Value },
                        }"
                        >{{ cinema.Label }}</router-link
                      >
                    </li> -->
                  </ul>
                </div>
              </div>

              <div class="mr-lg-3 d-none">
                <!-- uncomment below line to active country popup and disable next line below it -->
                <router-link
                  to="#"
                  class="nav-link px-2"
                >
                <!-- v-b-modal.countryModalRef -->

                  <div style="color: #fff" class="nav-link px-2">
                    {{ countrySelected }}
                    <img
                      src="@/assets/img/icons/location.svg"
                      height="auto"
                      width="18px"
                      alt="Country"
                    />

                    <!--src="@/assets/img/icon-location.png"-->
                  </div>
                </router-link>
              </div>

              <div class>
                <!-- <ul class="mb-0 text-white lang-data">
                    <li
                      v-for="(lang, index) in languageData"
                      :key="index"
                      v-on:click="onChangeLanguage(lang)"
                      class="text-uppercase d-inline"
                      :class="selectedLang == lang.ISOCode ? 'active': ''"
                    >{{lang.ISOCode}}&nbsp;</li>
                    <li class="d-inline">AR</li>
                </ul>-->

                <div
                  :class="[
                    'd-flex text-white lang-seprator mr-3',
                    isRTL ? 'rtl' : 'ltr',
                  ]"
                >
                  <div
                    v-for="(lang, index) in languageData"
                    :key="index"
                    v-on:click="onChangeLanguage(lang)"
                    class="text-uppercase"
                    :class="
                      selectedLang == lang.ISOCode
                        ? 'text-pink'
                        : 'text-light'
                    "
                  >
                    {{ lang.ISOCode }}&nbsp;
                  </div>
                </div>
              </div>

              <div
              class="d-flex align-items-center"  
              >
               
                
                <div
                @click="showProfileSidebar"
                :class="[
                  'd-flex header-drop align-items-center ',
                  isRTL ? 'header-drop-rtl' : '',
                ]">
                  <div
                  v-if="loggedInFlag"
                  class="text-light"
                 
                >
                  <!-- Hi ,  -->
                  <!-- {{ this.myUserDetails }} -->
                </div>
                <div v-else class="lh-1 text-light">{{ $t("HI_GUEST") }}</div>
                <div slot="button-content" class="toggler mr-2"  >
                    
                   <img
                      src="@/assets/img/icons/user-outline.svg"
                      height="40px"
                      width="40px"
                      alt="User"
                      :class="isRTL ? 'mx-2' : ''"
                    />
                    <!--src="@/assets/img/icons/user.svg"-->
                  </div>
                </div>
                  

                <!-- <b-dropdown variant="link" no-caret>
                
                  <b-dropdown-item v-if="!loggedInFlag" v-b-modal.signIn>{{
                    $t("SIGNIN")
                  }}</b-dropdown-item>
                  <b-dropdown-item v-if="!loggedInFlag" v-b-modal.signUp>{{
                    $t("SIGNUP")
                  }}</b-dropdown-item>
                  <b-dropdown-item to="/user-profile" v-if="loggedInFlag"
                    >&nbsp; {{ $t("MYPROFILE") }}</b-dropdown-item
                  >
                  <b-dropdown-divider />
                
                  <b-dropdown-item v-b-modal.support>{{
                    $t("SUPPORT")
                  }}</b-dropdown-item>
                  <b-dropdown-item
                    v-if="loggedInFlag"
                    v-on:click="onLogout()"
                    href="#"
                    >{{ $t("LOGOUT") }}</b-dropdown-item
                  >
                </b-dropdown> -->
              </div>
            </div>
          </div>
        </div>
         <!---New Profile SideBar: 30/07-->
         <div>
                  <div
                    class="new-profile-sidebar mobile-menu"
                    :class="profileSidebar ? 'show-menu' : 'hide-menu'"
                  >
                  <div>
                    <div class="profile-name-header">
                      <div>
                        <img
                          src="@/assets/img/icons/user-outline.svg"
                          height="30px"
                          width="40px"
                          alt="User"
                          :class="isRTL ? 'mx-2' : ''"
                        />
                      </div>
                      <div>
                        <p>Welcome,</p>
                        <p>{{myUserDetails.FirstName}} {{myUserDetails.LastName}}</p>
                      </div>
                      </div>
                      <div class="close-menu" @click="hideProfileSidebar">
                        <svg width="15px" height="15px" viewBox="-32 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="white">
<path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"/></svg>
                      </div>
                    </div>
                    <ul class="mobile-menu-list" v-if="!loggedInFlag">
                       <li  v-b-modal.signIn>{{
                    $t("SIGNIN")
                  }}</li>
                  <li  v-b-modal.signUp>{{
                    $t("SIGNUP")
                  }}</li>
                    </ul>
                    <ul class="mobile-menu-list"  v-if="loggedInFlag">
                      <li>
                        <a href="/user-profile">Profile</a>
                      </li>
                      <li>
                       <a href="/my-bookings">Booking History</a>
                      </li>
                      <!-- <li>
                        <a href="/my-vouchers">E-Vouchers</a>
                      </li> -->

                      <li v-on:click="onLogout()" href="#">
                        {{ $t("LOGOUT") }}
                      </li>
                    </ul>
                  </div>
                </div>
        <!-- MOBILE NAVIGATION BAR -->
        <div
          class="col-12 px-0 d-lg-none"
          :class="isRTL ? 'rtl' : ''"
          v-if="is_mobile_app == 1"
        ></div>
        <!--v-if="is_mobile_app = 1"-->
        <div class="col-12 px-0 d-lg-none" :class="isRTL ? 'rtl' : ''" v-else>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <router-link to="/">
                <!--  -->
                <img
                  src="@/assets/img/Cineco-Logo.png"
                  class="d-sm-none mr-2 mob_logo_header"
                  height="auto"
                  alt="icon"
                />
                <!--@/assets/img/icon-tt.png-->
                <img
                src="@/assets/img/Cineco-Logo.png"
                  class="nav-brand d-none d-sm-block"
                  alt="Logo"
                />
              </router-link>
              <!--router-link v-else to="/">
                <MyTiketi_final_logo1.png >
                <img
                  src="@/assets/img/newlogo.png"
                  class="d-sm-none mr-2 mobile_logo"
                  height="auto"
                  width="30px"
                  alt="Logo"
                />

                <@/assets/img/MyTiketi_final_logo1.png>

                <img
                  src="@/assets/img/newlogo.png"
                  class="nav-brand d-none d-sm-block"
                  alt="Mytiketi"
                />
              </router-link-->
            </div>

            <div v-if="false">
              <!--Latest-->
              <button v-b-modal.modal-1 class="search_icons_btn">
                <img src="@/assets/img/icons/search.svg" />
              </button>

              <div class="search_modal">
                <b-modal
                  id="modal-1"
                  hide-header
                  hide-footer
                  class="search_modal_sub"
                >
                  <div class="jm-search">
                    <input
                      type="text"
                      :class="
                        project == 'ticketak'
                          ? 'jm-search-ticketak'
                          : 'jm-search-mytiketi'
                      "
                      placeholder="Search for Movies"
                      v-on:keyup="searchData()"
                      v-model="searchValue"
                    />
                    <div
                      v-if="movieListSearch.length > 0"
                      class="search-results"
                    >
                      <ul class="list-unstyled mb-0">
                        <span class="ml-1 text-grey">Movies </span>
                        <li
                          v-on:click="movieListSearch = []"
                          v-for="(movie, movieListIndex) in movieListSearch"
                          :key="movieListIndex"
                        >
                          <router-link
                            class="text-dark"
                            :to="{
                              name: 'movie',
                              params: {
                                movieID: movie.Value,
                                cinemaID: '0',
                                props: {
                                  selectedFilter,
                                  cat_id: movie.CategoryID,
                                },
                              },
                            }"
                            >{{ movie.Label }}</router-link
                          >
                        </li>
                        <!-- <div class="seprator"></div>
                        <span class="ml-1 text-grey">Cinemas</span>
                        <li
                          v-on:click="cinemaListSearch = []"
                          v-for="(cinema, cinemaListIndex) in cinemaListSearch"
                          :key="cinemaListIndex"
                        >
                          <router-link
                            class="text-dark"
                            :to="{
                              name: 'cinemaDetails',
                              params: { cinemaId: cinema.Value },
                            }"
                            >{{ cinema.Label }}</router-link
                          >
                        </li> -->
                      </ul>
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>

            <!---Old Search Bar MObile View-->
            <div class="jm-search" v-if="false">
              <input
                type="text"
                :class="
                  project == 'ticketak'
                    ? 'jm-search-ticketak'
                    : 'jm-search-mytiketi'
                "
                placeholder="Search for Movies"
                v-on:keyup="searchData()"
                v-model="searchValue"
              />
              <div v-if="movieListSearch.length > 0" class="search-results">
                <ul class="list-unstyled mb-0">
                  <span class="ml-1 text-grey">Movies </span>
                  <li
                    v-on:click="movieListSearch = []"
                    v-for="(movie, movieListIndex) in movieListSearch"
                    :key="movieListIndex"
                  >
                    <router-link
                      class="text-dark"
                      :to="{
                        name: 'movie',
                        params: {
                          movieID: movie.Value,
                          cinemaID: '0',
                          props: { selectedFilter, cat_id: movie.CategoryID },
                          attr: 'search'
                        },
                      }"
                      >{{ movie.Label }}</router-link
                    >
                  </li>
                  <!-- <div class="seprator"></div>
                  <span class="ml-1 text-grey">Cinemas</span>
                  <li
                    v-on:click="cinemaListSearch = []"
                    v-for="(cinema, cinemaListIndex) in cinemaListSearch"
                    :key="cinemaListIndex"
                  >
                    <router-link
                      class="text-dark"
                      :to="{
                        name: 'cinemaDetails',
                        params: { cinemaId: cinema.Value },
                      }"
                      >{{ cinema.Label }}</router-link
                    >
                  </li> -->
                </ul>
              </div>
            </div>
            <!---Old Search Bar MObile View-->

            <div
              :class="[
                'header-drop d-md-flex d-sm-flex d-lg-flex d-xm-flex mobile_header',
                isRTL ? 'header-drop-rtl' : '',
              ]"
            >
              <div class="test_class">
                <SearchNew />
              </div>
              <div
                class="d-none"
                :class="
                  isRTL ? 'ml-sm-3 ml-md-3 ml-lg-3' : 'mr-sm-3 mr-md-3 mr-lg-3'
                "
              >
                <router-link @click.native="onShowModal()" to="/">
                  {{ countrySelected }}
                  <img
                    src="@/assets/img/icon-location.png"
                    height="auto"
                    width="20px"
                    alt="Location"
                  />
                </router-link>
              </div>
<div @click="showProfileSidebar">
  <button  type="button" class="btn btn-link ">
    <p class="toggler">
      <span></span> 
      <span></span> 
      <span></span>
    </p>
  </button>
              <!-- <b-dropdown variant="link" no-caret >
                <p slot="button-content" class="toggler" >
                  <span></span>
                  <span></span>
                  <span></span>
                </p>
                <b-dropdown-item v-if="!loggedInFlag" v-b-modal.signIn
                  >Sign In</b-dropdown-item
                >
                <b-dropdown-item v-if="!loggedInFlag" v-b-modal.signUp
                  >Sign Up</b-dropdown-item
                >
                <b-dropdown-item to="/user-profile" v-if="loggedInFlag"
                  >&nbsp; My Profile</b-dropdown-item
                >
                <b-dropdown-divider />
               
             
                <b-dropdown-item to v-b-modal.support>Support</b-dropdown-item>
                <b-dropdown-divider />
                <b-dropdown-item>
                  <div
                    :class="[
                      'd-flex text-white lang-seprator mr-3 justify-content-center',
                      isRTL ? 'rtl' : 'ltr',
                    ]"
                    style="gap: 10px"
                  >
                    <div
                      v-for="(lang, index) in languageData"
                      :key="index"
                      v-on:click="onChangeLanguage(lang)"
                      class="text-uppercase"
                      :class="
                        selectedLang == lang.ISOCode
                          ? 'text-danger'
                          : 'text-dark'
                      "
                    >
                      {{ lang.ISOCode }}&nbsp;
                    </div>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="loggedInFlag"
                  v-on:click="onLogout()"
                  href="#"
                  >Logout</b-dropdown-item
                >
              </b-dropdown> -->
            </div>
            </div>
          </div>
          <div
            class="d-flex justify-content-between mt-2 mt-sm-4 mt-md-4 mt-lg-4"
          >
            <div>
              <router-link @click.native="fetchUserDetails()" to="/"
                >Home</router-link
              >
            </div>
            <div>
              <router-link to="/movies">Movies</router-link>
            </div>
            <!-- <div>
              <router-link to="/events">Events</router-link>
            </div> -->
            <!--<div>
              <router-link to="/offers">Offers</router-link>
            </div>-->
          </div>
        </div>
      </div>
    </nav>

    <!-- COUNTRY SELECTION MODAL -->
    <div v-if="is_mobile_app == 0">
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        ref="countryModalRef"
        id="countryModalRef"
        hide-header
        hide-footer
        class="country-modal"
      >
        <button
          v-if="countrySelected && String(countrySelected).length > 0"
          type="button"
          @click="hideCountryModal()"
          aria-label="Close"
          class="close"
        >
          ×
        </button>
        <div class="modal-title">{{ $t("CHOOSE_YOUR_COUNTRY") }} </div>

        <div class="p-3">
          <div class="row">
            <div
              :class="
                project == 'myticketi'
                  ? 'text-center text-dark col'
                  : 'text-center text-white col'
              "
              v-for="(country, index) in countries"
              :index="index"
              :key="index"
              v-on:click="setCountry(country, true)"
            >
              <img
                :src="country.Flag"
                height="60px"
                width="100px"
                alt="Cineco"
              />
              <h6 class="pt-3">{{ country.CountryName }}</h6>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- Register User Bonus -->
    <b-modal
      ref="registerbonusoffer"
      id="registerbonusoffer"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-header
      hide-footer
    >
      <div class="modal-title">Hey!</div>
      <div class="text-center text-white mt-3 mt-md-0">
        You have got 100 KES off on your next transaction.
        <br />Refer your friends to earn upto 500 KES more.
      </div>
      <div class="text-center my-3">
        <button
          v-on:click="onCloseCurrentModal('registerbonusoffer')"
          class="ticketak-btn"
        >
          OK
        </button>
      </div>
    </b-modal>

    <!-- SUPPORT MODAL -->

    <b-modal
      id="support"
      no-close-on-backdrop
      ref="support"
      hide-header
      hide-footer
      centered
    >
      <button
        type="button"
        @click="hideContactUs()"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
      <div class="col-sm-9 col-md-10 mx-auto">
        <div class="modal-title">CONTACT US</div>

        <form
          @submit.prevent="validateBeforeSubmit('contactUs')"
          data-vv-scope="contactUs"
        >
          <div class="text-danger my-2 text-center">
            {{ contactUsDetails.errorMessage }}
          </div>
          <input
            name="Name"
            type="text"
            v-validate="'required'"
            placeholder="Enter Your Name"
            v-model="contactUsDetails.name"
          />
          <span
            v-show="errors.has('contactUs.Name')"
            class="help text-danger text-center is-danger"
            >{{ errors.first("contactUs.Name") }}</span
          >

          <input
            v-model="contactUsDetails.email"
            v-validate="'required'"
            name="Email"
            type="text"
            placeholder="Enter Your Email Address"
          />
          <span
            v-show="errors.has('contactUs.Email')"
            class="help text-danger text-center is-danger"
            >{{ errors.first("contactUs.Email") }}</span
          >

          <input
            v-model="contactUsDetails.mobile"
            v-validate="'required|min:8|max:12'"
            name="Number"
            type="number"
            placeholder="Enter Your Contact Number"
          />
          <span
            v-show="errors.has('contactUs.Number')"
            class="help text-danger text-center is-danger"
            >{{ errors.first("contactUs.Number") }}</span
          >

          <div class="pc-input form-control btn-group b-dropdown dropdown mb-2">
            <b-dropdown
              id="dropdown-1"
              variant="default"
              :text="selectedQuery"
              class="d-flex align-items-center"
            >
              <b-dropdown-item
                class="pc-input form-control"
                v-for="(query, queryKey) in contactUsDetails.queries"
                v-on:click="onSelectQuery(query)"
                :key="queryKey"
                >{{ query }}</b-dropdown-item
              >
            </b-dropdown>
          </div>

          <textarea
            v-model="contactUsDetails.message"
            v-validate="'required'"
            name="Message"
            type="text"
            placeholder="Enter Your Message"
          />
          <span
            v-show="errors.has('contactUs.Message')"
            class="help text-danger text-center is-danger"
            >{{ errors.first("contactUs.Message") }}</span
          >

          <input type="submit" :value="$t('SUBMIT')"  />
        </form>
      </div>
    </b-modal>
    <!-- SUPPORT MODAL ENDS -->

    <!-- FORGOTPASSWORD -->
    <b-modal
      id="forgotPassword"
      ref="forgotPassword"
      hide-header
      hide-footer
      centered
    >
      <button
        type="button"
        @click="hideForgotPassword()"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
      <div class="col-sm-9 col-md-10 mx-auto" v-if="modal.forgotPassword.info">
        <div class="modal-title">{{ $t("FORGOT_PASSWORD") }}</div>

        <div class="text-danger text-center my-2">
          {{ socialLoginError.error }}
        </div>
        <form
          @submit.prevent="validateBeforeSubmit('forgotPassword')"
          data-vv-scope="forgotPassword"
        >
          <label
            >-
            {{ $t("ENTER_YOUR_RESGISTERED_EMAIL_OR_MOBILE_NUMBER") }} -</label
          >
          <div class="text-danger my-2 text-center">
            {{ resErrorMessage.signInError }}
          </div>
          <input
            name="Email"
            type="text"
            v-validate="'required'"
            :placeholder="$t('EMAIL_OR_PHONENUMBER')"
            v-model="userDetails.signinmodel"
          />
          <span
            v-show="errors.has('forgotPassword.Email')"
            class="help text-danger text-center is-danger"
            >{{ errors.first("forgotPassword.Email") }}</span
          >
          <input type="submit" :value="$t('PROCEED')" />
        </form>
      </div>
      <div class="col-sm-9 col-md-10 mx-auto" v-if="modal.forgotPassword.OTP">
        <div class="modal-title">{{ $t("FORGOT_PASSWORD") }}</div>
        <div class="text-danger my-2 text-center">
          {{ resErrorMessage.otpError }}
        </div>
        <form
          @submit.prevent="validateBeforeSubmit('forgotPasswordOTP')"
          data-vv-scope="forgotPasswordOTP"
        >
          <label>- {{ $t("ENTER_OTP") }} -</label>

          <input
            name="OTP"
            type="number"
            v-validate="'required'"
            placeholder="OTP"
            class="text-center"
            v-model="userDetails.OTP"
          />
          <span
            v-show="errors.has('forgotPasswordOTP.OTP')"
            class="help is-danger"
            >{{ errors.first("forgotPasswordOTP.OTP") }}</span
          >

          <input type="submit" :value="$t('VERIFY_OTP')" />
        </form>
      </div>

      <!-- RESET PASSWORD -->
      <div
        class="col-sm-9 col-md-10 mx-auto"
        v-if="modal.forgotPassword.resetPassword"
      >
        <div class="modal-title">{{ $t("FORGOT_PASSWORD") }}</div>
        <div class="text-danger my-2 text-center">
          {{ resErrorMessage.otpError }}
        </div>
        <form
          @submit.prevent="validateBeforeSubmit('updateProfile')"
          data-vv-scope="updateProfile"
        >
          <label>- {{ $t("ENTER_NEW_PASSWORD") }} -</label>

          <input
            name="New Password"
            type="password"
            v-validate="'required|min:8|verify_password'"
            placeholder="Password"
            v-model="userDetails.NewPassword"
          />
          <span
            v-if="
              userDetails.NewPassword.length > 0 &&
              userDetails.NewPassword.length < 8
            "
            class="help is-danger"
            >Password must be 8 characters long.</span
          >
          <span
            v-if="
              userDetails.NewPassword != '' &&
              !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(
                userDetails.NewPassword
              )
            "
            class="help is-danger"
            >The password must contain at least: one uppercase character, one
            lowercase character, one number, and one special character (E.g. , .
            _ & ? etc)</span
          >
          <span
            v-if="userDetails.NewPassword.length >= 8 ? '' : ''"
            v-show="errors.has('updateProfile.New Password')"
            class="help is-danger"
            style="color: #fff"
            >{{ errors.first("updateProfile.New Password") }}</span
          >

          <input
            name="Confirm Password"
            type="password"
            v-validate="'required|min:8|verify_password'"
            placeholder="Confirm Password"
            v-model="userDetails.repassword"
          />
          <span
            v-show="errors.has('updateProfile.Confirm Password')"
            class="help is-danger"
            >{{ errors.first("updateProfile.Confirm Password") }}</span
          >

          <input type="submit" :value="$t('SUBMIT')" />
        </form>
      </div>
    </b-modal>

    <!-- SIGN IN MODAL -->
    <b-modal id="signIn" ref="signInModal" hide-header hide-footer centered>
      <button
        type="button"
        @click="hideSignIn()"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
      <div class="col-sm-9 col-md-10 mx-auto" v-if="modal.signIn.info">
        <div v-if="project == 'ticketak'" class="modal-title">
          Welcome to Ticketak
        </div>
        <div v-if="project == 'myticketi'" class="modal-title">
          {{ $t("WELCOME_TO_WANASA_TIME") }}
        </div>

        <!-- <label>{{ $t("LOGIN_EASILY_USING") }}</label>-->
        <div class="text-danger text-center my-2">
          {{ socialLoginError.error }}
        </div> 
        <div class="external-login d-none">
          <!-- <button @click="fbFirebaseSignIn" class="new_pop_btn">
            <img
              src="@/assets/img/svg/icon-facebook.svg"
              height="auto"
              width="20px"
              alt="Google-icon"
            />
            {{ $t("FACEBOOK") }}
          </button> -->
          <!-- <fb-signin-button
            v-if="false"
            :class="project == 'myticketi' ? 'btn-facebook_my' : 'btn-facebook'"
            :params="fbSignInParams"
            @success="onSignFBInSuccess"
            @error="onSignFBInError"
          >
            <div>
              <img
                src="@/assets/img/svg/icon-facebook.svg"
                height="auto"
                width="20px"
                alt="Facebook-icon"
              />
              Facebook
            </div>
          </fb-signin-button> -->
          <div>
            <!-- <button @click="googleFirebaseSignIn" class="new_pop_btn">
              <img
                src="@/assets/img/svg/icon-google.svg"
                height="auto"
                width="20px"
                alt="Google-icon"
              />
              {{ $t("GOOGLE") }}
            </button> -->
          </div>

          <g-signin-button
            v-if="false"
            :class="project == 'myticketi' ? 'btn-google_my' : 'btn-google'"
            :params="googleSignInParams"
            @success="onGoogleSignInSuccess"
            @error="onGoogleSignInError"
          >
            <img
              src="@/assets/img/svg/icon-google.svg"
              height="auto"
              width="20px"
              alt="Google-icon"
            />
            Google
          </g-signin-button>
        </div>
        <form
          @submit.prevent="validateBeforeSubmit('signIn')"
          data-vv-scope="signIn"
        >
          <!-- <label>- {{ $t("OR_USING_EMAIL") }} -</label> -->
          <div class="text-danger my-2 text-center">
            {{ resErrorMessage.signInError }}
          </div>
          <input
            name="Email"
            type="text"
            v-validate="'required'"
            :placeholder="$t('EMAIL_OR_PHONENUMBER')"
            v-model="userDetails.signinmodel"
          />
          <span
            v-show="errors.has('signIn.Email')"
            class="help text-danger text-center is-danger"
            >{{ errors.first("signIn.Email") }}</span
          >
          <!-- PASSWORD -->
          <input
            v-model="userDetails.password"
            v-validate="'required'"
            name="Password"
            type="password"
            :placeholder="$t('PASSWORD')"
          />
          <span
            v-show="errors.has('signIn.Password')"
            class="help text-danger text-center is-danger"
            >{{ errors.first("signIn.Password") }}</span
          >
          <div class="d-flex justify-content-between mb-4">
            <div
              class="d-flex align-items-center"
              :class="[isRTL ? 'ltr' : '']"
            >
              <input id="remember" type="checkbox" checked />
              <label for="remember" class="mb-0">{{ $t("REMEMBER_ME") }}</label>
            </div>
            <div
              class="d-flex align-items-center"
              :class="[isRTL ? 'ltr' : '']"
            >
              <a href="#" @click="showForgotPassword()" class="text-black">{{
                $t("FORGOT_PASSWORD")
              }}</a>
              <!--<router-link to="#" v-b-modal.forgotPassword class="text-white">Forgot Password?</router-link>-->
            </div>
          </div>

          <input type="submit" :value="$t('SIGNIN')" />
        </form>
      </div>
      <div class="col-sm-9 col-md-10 mx-auto" v-if="modal.signIn.OTP">
        <div class="modal-title">{{ $t("WELCOME_TO_WANASA_TIME") }}</div>
        <div class="text-danger my-2 text-center">
          {{ resErrorMessage.otpError }}
        </div>
        <form
          @submit.prevent="validateBeforeSubmit('signInVerifyOTP')"
          data-vv-scope="signInVerifyOTP"
        >
          <label>- {{ $t("ENTER_OTP") }} -</label>

          <input
            name="OTP"
            type="number"
            v-validate="'required'"
            placeholder="OTP"
            class="text-center"
            v-model="userDetails.OTP"
          />
          <span
            v-show="errors.has('signInVerifyOTP.OTP')"
            class="help is-danger"
            >{{ errors.first("signInVerifyOTP.OTP") }}</span
          >

          <input type="submit" :value="$t('VERIFY_OTP')" />
        </form>
      </div>
      <div class="bg-white text-center py-3">
        {{ $t("DONT_HAVE_ACCOUNT") }}
        <router-link to="#" v-b-modal.signUp class="text-pink">{{
          $t("SIGNUP")
        }}</router-link>
      </div>
    </b-modal>

    <!-- SIGN UP MODAL -->
    <b-modal
      no-close-on-backdrop
      id="signUp"
      ref="signUpModal"
      title="Sign up"
      hide-footer
      hide-header
    >
      <button
        type="button"
        v-on:click="hideSignUp()"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
      <div class="col-sm-9 col-md-10 mx-auto" v-if="modal.signUp.info">
        <div v-if="project == 'ticketak'" class="modal-title">
          Signup to Ticketak
        </div>
        <div v-if="project == 'myticketi'" class="modal-title">
          {{ $t("SIGNUP_TO_WANASA_TIME") }}
        </div>
        <label>{{ $t("ENTER_YOUR_CONTACT_INFORMATION") }}</label>
        <form
          class="mb-2"
          @submit.prevent="validateBeforeSubmit('signUp')"
          data-vv-scope="signUp"
        >
          <div class="form-row">
            <div class="col-sm-12">
              <input
                type="text"
                :placeholder="$t('ENTER_YOUR_FULL_NAME')"
                v-model="userDetails.fullName"
                required
              />
            </div>
            <!-- <div class="col-sm-6">
              <input type="text" placeholder="Last Name" v-model="userDetails.lastName" required />
            </div>-->
          </div>
          <input
            type="email"
            name="email"
            id="email"
            v-validate="'required|email'"
            :placeholder="$t('EMAIL')"
            v-model="userDetails.email"
          />
          <span
            v-show="errors.has('signUp.email')"
            class="help is-danger pl-3 pb-2"
            >{{ errors.first("signUp.email") }}</span
          >
          <div class="row align-items-center mb-3">
            <div class="col-12 signup-input-tel">
              <VuePhoneNumberInput
                  v-model="userDetails.phoneNumber"
                  @update="onChangeCountry($event)"
                  :default-country-code="
                            countryList.find(
                              o => o.phonecode == countryISOCode
                            ) &&
                              countryList.find(
                                o => o.phonecode == countryISOCode
                              ).isoCode
                  "
                  id="phoneNumber1"
                 />
            </div>
            
                 <!-- {{userDetails.phoneNumber}} -->
            <!-- <div class="col-3 pr-0 country-code-drop pb-3">
              <b-dropdown
                no-flip
                v-if="CountryCodeList.length > 0"
                class="pc-input form-control"
                :text="'+' + DefaultCountryCode"
                variant="default"
                slot="append"
              >
                <b-dropdown-item
                  class
                  @click="onChangeCountry(country)"
                  v-for="(country, countryIndex) in CountryCodeList"
                  :key="countryIndex"
                  >{{ country.CountryName }} (+{{
                    country.CountryISOCode
                  }})</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <div class="col-9 pr-0 pr-xl-3 text-black">
              <input
                type="number"
                name="Phone Number"
                v-validate="'required|min:7|max:10|numeric'"
                :placeholder="$t('PHONE_NUMBER')"
                v-model="userDetails.phoneNumber"
              />
            </div>
            <span
              v-show="errors.has('signUp.Phone Number')"
              class="help is-danger pl-3 pb-2"
              >{{ errors.first("signUp.Phone Number") }}</span
            > -->
          </div>

          <b-form-group>
            <b-form-radio-group
              id="btn-radios-2"
              v-model="selected"
              :options="options"
              buttons
              button-variant="outline-primary"
              size="lg"
              name="radio-btn-outline"
              class="btn-z-index"
            ></b-form-radio-group>
          </b-form-group>

          <!-- <div class="d-flex align-items-center mb-2">
            <input id="male" name="male" v-model="userDetails.Male" value="1" type="radio" />
            <label for="male" name="male" class="mb-0 mr-2">Male</label>
            <input id="female" name="female" v-model="userDetails.Female" value="0" type="radio" />
            <label for="female" name="female" class="mb-0">Female</label>
          </div>-->
          <input
            type="password"
            :placeholder="$t('PASSWORD')"
            name="Password"
            @blur="checkPassword(userDetails.password)"
            v-model="userDetails.password"
          />
          <span v-if="!passwordBool" class="help is-danger text-black">{{
            $t("PASSWORD_VAILIDATION")
          }}</span>
          <!-- <input
            type="text"
            class
            :placeholder="$t('REFERRAL_CODE')"
            v-model="referralCode"
          /> -->
          <!-- <vue-tel-input
            v-validate="'required|min:3'"
            v-model="userDetails.phoneNumber"
            :preferredCountries="['us', 'gb', 'ua']"
            @onInput="onInput"
          ></vue-tel-input>-->
          <!-- <input
            name="password"
            type="password"
            v-model="userDetails.password"
            v-validate="{ is: userDetails.confirmedPassword }"
            placeholder="Password"
          >
          <input
            type="password"
            v-model="userDetails.confirmedPassword"
            placeholder="Confirm Password"
          >
          <span
            v-show="errors.has('signUp.password')"
            class="help is-danger"
          >{{ errors.first('signUp.password') }}</span>-->
          <div class="text-danger my-2 text-center">
            {{ resErrorMessage.signUpError }}
          </div>
          <div
            class="text-black text-center mb-1"
            @click="registerApi()"
            v-if="verifyMe"
          >
            Click Here to Verify
          </div>
          <input type="submit" :value="$t('SUBMIT')" />
        </form>
        <div class="text-danger text-center my-2">
          {{ socialLoginError.error }}
        </div>

        <!-- <label>{{ $t("OR_SIGN_UP_EASILY_USING") }}</label> -->
        <!-- <div class="external-login d-none">
          <button @click="fbFirebaseSignIn" class="new_pop_btn">
            <img
              src="@/assets/img/svg/icon-facebook.svg"
              height="auto"
              width="20px"
              alt="Google-icon"
            />
            {{ $t("FACEBOOK") }}
          </button>
          <fb-signin-button
            v-if="false"
            :class="project == 'myticketi' ? 'btn-facebook_my' : 'btn-facebook'"
            :params="fbSignInParams"
            @success="onSignFBInSuccess"
            @error="onSignFBInError"
          >
            <div>
              <img
                src="@/assets/img/svg/icon-facebook.svg"
                height="auto"
                width="20px"
                alt="Facebook-icon"
              />
              Facebook
            </div>
          </fb-signin-button>
          <div class="mx-2">&nbsp;</div>
          <div>
            <button @click="googleFirebaseSignIn" class="new_pop_btn">
              <img
                src="@/assets/img/svg/icon-google.svg"
                height="auto"
                width="20px"
                alt="Google-icon"
              />
              {{ $t("GOOGLE") }}
            </button>
          </div>
          <g-signin-button
            v-if="false"
            :class="project == 'myticketi' ? 'btn-google_my' : 'btn-google'"
            :params="googleSignInParams"
            @success="onGoogleSignInSuccess"
            @error="onGoogleSignInError"
          >
            <img
              src="@/assets/img/svg/icon-google.svg"
              height="auto"
              width="20px"
              alt="Google-icon"
            />
            Google
          </g-signin-button>
        </div> -->
      </div>

      <div
        class="col-sm-9 col-md-10 mx-auto"
        v-if="modal.signUp.contactDetails"
      >
        <div v-if="project == 'ticketak'" class="modal-title">
          Signup to Ticketak
        </div>
        <div v-if="project == 'myticketi'" class="modal-title">
          {{ $t("SIGNUP_TO_WANASA_TIME") }}
        </div>
        <label>ENTER YOUR CONTACT INFORMATION</label>
        <form
          class="mb-4"
          @submit.prevent="validateBeforeSubmit('signUp')"
          data-vv-scope="signUp"
        >
          <div class="form-row">
            <div class="col-sm-6">
              <input
                type="text"
                placeholder="First Name"
                v-model="userDetails.firstName"
                required
              />
            </div>
            <div class="col-sm-6">
              <input
                type="text"
                placeholder="Last Name"
                v-model="userDetails.lastName"
                required
              />
            </div>
          </div>
          <input
            type="email"
            v-validate="'required|email'"
            placeholder="Email"
            v-model="userDetails.email"
          />
          <input
            type="number"
            v-validate="'required'"
            placeholder="Phone Number"
            v-model="userDetails.phoneNumber"
          />
          <!-- <vue-tel-input
            v-validate="'required|min:3'"
            v-model="userDetails.phoneNumber"
            :preferredCountries="['us', 'gb', 'ua']"
            @onInput="onInput"
          ></vue-tel-input>-->
          <!-- <input
            name="password"
            type="password"
            v-model="userDetails.password"
            v-validate="{ is: userDetails.confirmedPassword }"
            placeholder="Password"
          >
          <input
            type="password"
            v-model="userDetails.confirmedPassword"
            placeholder="Confirm Password"
          >
          <span
            v-show="errors.has('signUp.password')"
            class="help is-danger"
          >{{ errors.first('signUp.password') }}</span>-->
          <input type="submit" :value="$t('SUBMIT')" />
        </form>
        <div class="text-danger text-center my-2">
          {{ socialLoginError.error }}
        </div>
        <!-- <label>OR SIGN UP EASILY USING</label> -->
        <div class="external-login">
          <!-- <button @click="fbFirebaseSignIn" class="new_pop_btn">
            <img
              src="@/assets/img/svg/icon-facebook.svg"
              height="auto"
              width="20px"
              alt="Google-icon"
            />
            Facebook
          </button> -->
          <!-- <fb-signin-button
            v-if="false"
            :class="project == 'myticketi' ? 'btn-facebook_my' : 'btn-facebook'"
            :params="fbSignInParams"
            @success="onSignFBInSuccess"
            @error="onSignFBInError"
          >
            <div>
              <img
                src="@/assets/img/svg/icon-facebook.svg"
                height="auto"
                width="20px"
                alt="Facebook-icon"
              />
              Facebook
            </div>
          </fb-signin-button> -->
          <div class="mx-2">&nbsp;</div>
          <div>
            <!-- <button @click="googleFirebaseSignIn" class="new_pop_btn">
              <img
                src="@/assets/img/svg/icon-google.svg"
                height="auto"
                width="20px"
                alt="Google-icon"
              />
              Google
            </button> -->
          </div>

          <!-- <g-signin-button
            v-if="false"
            :class="project == 'myticketi' ? 'btn-google_my' : 'btn-google'"
            :params="googleSignInParams"
            @success="onGoogleSignInSuccess"
            @error="onGoogleSignInError"
          >
            <img
              src="@/assets/img/svg/icon-google.svg"
              height="auto"
              width="20px"
              alt="Google-icon"
            />
            Google
          </g-signin-button> -->
        </div>
      </div>
      <div class="col-sm-9 col-md-10 mx-auto" v-if="modal.signUp.OTP">
        <div v-if="project == 'ticketak'" class="modal-title">
          Signup to Ticketak
        </div>
        <div v-if="project == 'myticketi'" class="modal-title">
          {{ $t("SIGNUP_TO_WANASA_TIME") }}
        </div>
        <label>{{ $t("Your OTP has been sent to your registered email address") }}
</label>
        <div class="text-danger my-2 text-center">
          {{ resErrorMessage.otpError }}
        </div>
        <div
          class="text-white text-center"
          v-b-modal.signUp
          v-if="resErrorMessage.Attempt"
        >
          Please click here to signup again
        </div>
        <form
          v-if="!resErrorMessage.Attempt"
          class="mb-4"
          @submit.prevent="validateBeforeSubmit('signUpVerifyOTP')"
          data-vv-scope="signUpVerifyOTP"
        >
          <input
            type="number"
            v-validate="'required'"
            :placeholder="$t('ENTER_OTP_HERE')"
            v-model="userDetails.OTP"
            class="text-center"
          />
          <input type="submit" :value="$t('SUBMIT')"/>
        </form>
      </div>

      <div class="bg-white text-center py-3">
        {{ $t("ALREADY_HAVE_AN_ACCOUNT") }}
        <router-link to="#" v-b-modal.signIn class="text-pink"
          >&nbsp; {{ $t("SIGNIN") }}</router-link
        >
      </div>
    </b-modal>
  </div>
</template>
<script>
import throttle from "lodash.throttle";
import VuePhoneNumberInput from "vue-phone-number-input";
import countryCodes from "@/helper/countryCodes.js";

import { EventBus } from "@/main";
import { setI18nLanguage } from "@/plugins/i18n";
// import firebase from "firebase";
import {
  PROJECT,
  METAWEBSITE,
  METAORGANIZATION,
  metaInfo,
} from "@/helper/constant.js";
import { makeRequest } from "@/helper/internet.js";
//import VeeValidate from "vee-validate";
import {
  LanguageService,
  CountryService,
  TokenService,
  ReferralService,
} from "@/services/storage.service";
import { validationMixin } from "vuelidate";
import { required, minLength, email, password } from "vuelidate/lib/validators";
import VeeValidate from "vee-validate";
import router from "../../router";
import { mapGetters } from "vuex";
import SearchNew from "@/components/pages/search";
//import Zendesk from "@dansmaculotte/vue-zendesk";

VeeValidate.Validator.extend("verify_password", {
  getMessage: (field) =>
    `The password must contain at least: one uppercase character, one lowercase character, one number, and one special character (E.g. , . _ & ? etc)`,
  validate: (value) => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  },
});

VeeValidate.Validator.extend("verify_forgot_passwrd", {
  getMessage: (field) =>
    `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: (value) => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  },
});

export default {
  components: {
    SearchNew,
    VuePhoneNumberInput

  },
  computed: {
    ...mapGetters(["isRTL"]),
    allLanguageDataMenu() {
      let array = [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "MOVIES",
          path: "/movies",
        }
      ];
      if (this.selectedLang == "en" && false) {
        array.push({
          name: "REFER_SAVE",
          path: "/refer",
        });
      }
      return array;
    },
  },
  data() {
    return {
      is_mobile_app: 0,
      countryList: countryCodes,
      profileSidebar: false,
      // Jigar
      // tempToken: null,
      // Jigar
      showBonusPopup: false,
      myUserDetails: {},
      checkPhoneValid: false,
      DefaultCountryCode: null,
      project: PROJECT,
      metaWebsite: METAWEBSITE,
      metaOrganization: METAORGANIZATION,
      tempToken: null,
      referralCode: "",
      searchValue: "",
      movieListSearch: [],
      selectedFilter: {},
      languageData: [],
      cinemaListSearch: [],
      fbSignInParams: {
        scope: "email",
        return_scopes: false,
      },
      /**
       * The Auth2 parameters, as seen on
       * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
       * As the very least, a valid client_id must present.
       * @type {Object}
       */
      googleSignInParams: {
        // clientId: 'YOUR_APP_CLIENT_ID.apps.googleusercontent.com'

        //"254680074981-k57uhepk3ve5s85gqepnoiola2baboq6.apps.googleusercontent.com" //mytiketi
        //"193276772057-94fl0er49a467hjm0m1jmpnm7ondunjf.apps.googleusercontent.com" //ticketak

        // client_id: "715055681361-1ku1nj1gptsogqi2ldoelotpltjepvql.apps.googleusercontent.com",
        // clientId: "715055681361-1ku1nj1gptsogqi2ldoelotpltjepvql.apps.googleusercontent.com",

        client_id:
          "363473089674-i72te70v7gmtftp9e8b1bk2e0d72m9kl.apps.googleusercontent.com",
        clientId:
          "363473089674-i72te70v7gmtftp9e8b1bk2e0d72m9kl.apps.googleusercontent.com",
      },
      loggedInFlag: false,
      countries: [],
      country: "",
      city: "",
      countrySelected: "",
      citySelected: "",
      onScroll: true,
      forgotPasswordSection: 0,
      page: "",
      cityDropDown: false,
      searchValue: "",
      mobileSearch: false,
      searchQuery: "",
      options: {
        placeholder: "Search for Movies",
        inputClass: "header-input-box form-control",
        inputMainClass: "header-input-box form-control",
      },
      mobileOptions: {
        placeholder: "Search for Movies",
        inputClass: "sb-search-input",
        inputMainClass: "",
      },
      resErrorMessage: {
        signUpError: "",
        signInError: "",
        otpError: "",
        Attempt: false,
      },
      loginErrorMessage: "Please Enter Your Credentials",
      registerErrorMessage: "ENTER CONTACT INFORMATION",
      errorMessage: {
        userName: "",
        email: "",
        phoneNumber: "",
        password: "",
        conditions: false,
      },
      errorMessageStatus: {
        userName: false,
        email: false,
        phoneNumber: false,
        password: false,
        conditions: false,
      },
      status: {
        signUpFlag: true,
      },
      inputData: {
        userName: "",
        email: "",
        phoneNumber: "",
        password: "",
        conditions: false,
        code: "",
        ReSetCode: "",
      },
      options: [
        { text: "Male", value: "1" },
        { text: "Female", value: "0" },
      ],
      selected: "1",
      classFlag: {
        onSignUp: "",
        onOTP: "",
        otpComplete: "",
        onSignIn: "",
      },
      // User Details
      userDetails: {
        displayName: "",
        username: "",
        password: "",
        NewPassword: "",
        fullName: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        confirmedPassword: "",
        countryCode: "",
        OTP: "",
        signinmodel: "",
        password: "",
        repassword: "",
        Male: "",
        Female: "",
      },
      countryISOCode: "",
      modal: {
        signUp: {
          info: true,
          OTP: false,
        },
        signIn: {
          info: true,
          OTP: false,
        },
        forgotPassword: {
          info: true,
          OTP: false,
          resetPassword: false,
        },
      },
      passwordBool: true,
      CountryCodeList: [],
      selectedQuery: "Select Query",
      contactUsDetails: {
        name: "",
        email: "",
        mobile: "",
        message: "",
        errorMessage: "",
        queries: [
          "Ticket pickup and Home delivery",
          "Offers",
          "Confirmation not received",
          "Cancellation/Exchange request",
          "Winpins/Gift Voucher",
          "Unsuccessful transaction",
          "Ticket booking queries",
          "Cinema related feedback",
          "Others",
        ],
      },
      selectedLang: "en",
      isUserLoggedIn: false,
      // OTP
      otpDetails: {
        otpError: {},
        otpInputs: {
          first: "",
          second: "",
          third: "",
          fourth: "",
        },
        status: {
          buttonFlag: true,
        },
      },
      verifyMe: false,
      socialLoginError: {
        error: "",
      },
      loginData: {
        loginInput: {
          email: "",
          password: "",
          conditions: false,
        },
        errorMessage: {
          email: "",
          password: "",
          conditions: false,
        },
        errorMessageStatus: {
          email: false,
          password: false,
          conditions: false,
        },
        button: true,
      },
      messageCopy: "",
      emailReg:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  mixins: [validationMixin],

  beforeMount() {
    if (this.project == "ticketak") {
      this.googleSignInParams.client_id =
        "193276772057-94fl0er49a467hjm0m1jmpnm7ondunjf.apps.googleusercontent.com";
    } else if (this.project == "myticketi") {
      this.googleSignInParams.client_id =
        "254680074981-k57uhepk3ve5s85gqepnoiola2baboq6.apps.googleusercontent.com";
    }
    this.page = this.$route.path;
    // let country = CountryService.getCountry();
    const country = {
        CountryID: "113",
        CountryISOCode: "973",
        CountryName: "Bahrain",
        Flag:
          "https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c7796d3b50ad.png",
        ISOCode: "bh"
      };
      CountryService.saveCountry(country);
    if (country) {
      this.countrySelected = country.CountryName;
    } else {
      this.apiLocation();
    }
 
    let countryObj = {};
    // if (country) {
    //   if (window.location.origin == "http://kw.ticketak.com") {
    //     countryObj = {
    //       CountryID: "115",
    //       CountryName: "Kuwait",
    //       Flag:
    //         "https://img.ticketak.com/assets/images/countryflags/5c779755bdc95.png"
    //     };
    //     CountryService.saveCountry(countryObj);
    //   } else if (window.location.origin == "http://uae.ticketak.com") {
    //     countryObj = {
    //       CountryID: "230",
    //       CountryName: "UAE",
    //       Flag:
    //         "https://img.ticketak.com/assets/images/countryflags/5c7796d3b50ad.png"
    //     };
    //   }
    // }
    // else {

    // this.getAllCountry();
    // }
    this.fetchLanguageData();
    this.token = TokenService.getToken();
    if (this.token) {
      this.loggedInFlag = true;
      this.fetchUserDetails();
    }
  },
  created() {
    // window.addEventListener("scroll", this.theScroll);
    // firebase.auth().onAuthStateChanged((user) => {
    //   console.log({ user });
    //   // this.user = user
    // });
  },

  mounted: function () {
    //this.$zendesk.load("0fa8096b-11c0-45f1-9dfe-e82062b79b75");
    // let countryData1 = {
    //     CountryID: '113', 
    //     CountryName: 'Bahrain', 
    //     Flag: 'https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c7796d3b50ad.png', 
    //     CountryISOCode: '973', 
    //     ISOCode: 'bh'
    //   }
    
      // CountryService.saveCountry(countryData1);
    let countryData = CountryService.getCountry();
    if(countryData != null) {
      this.countryISOCode = countryData.CountryISOCode
    }
    // this.countryISOCode = countryData.CountryISOCode || '';
    this.getAllCountry();
    this.getGeoLocation();
    this.getAllGetCountryList();
    let lang = LanguageService.getLanguage();
    this.selectedLang = (lang && lang["lang"]) || "en";
    this.referralCode = ReferralService.getReferral() || "";
    EventBus.$on("openSignInModal", () => {
      this.$refs.signInModal.show();
    });
    EventBus.$on("fetchuser", () => {
      this.fetchUserDetails();
    });
    EventBus.$on("openSignUpModal", () => {
      this.referralCode = ReferralService.getReferral() || "";
      console.log("Referral Code :", this.referralCode);
      if (!this.loggedInFlag) {
        this.$refs.signUpModal.show();
      }
    });
    EventBus.$on("selectedCountry", (countryName) => {
      this.countrySelected = countryName;
    });
  
    // EventBus.$on("getUserDetails", user => {
    //   //   console.log(">>>>>>>><<<<<<<", user);
    // });

    // EventBus.$on("LoginUser", user => {
    //   if (user.status == true) {
    //     this.loggedInFlag = true;
    //   }
    // });
  },
  
  methods: {
    async apiLocation() {
      let flag = false;
          const response = await fetch(
            "https://api.ipgeolocation.io/ipgeo?apiKey=fc17cbd3f0614b5db28ecdaea34b0fdd"
          );
          const apiResData = await response.json();
          this.countries.map((data) => {
              if(apiResData.country_name == data.CountryName) {
                this.setCountry(data);
                flag = true;
              }  
          })
          if(!flag) {
            let country = {
                CountryID: '113', 
                CountryName: 'Bahrain', 
                Flag: 'https://adminapi-wanastime.wanasatime.com/uploads/assets/images/countryflags/5c7796d3b50ad.png', 
                CountryISOCode: '973', 
                ISOCode: 'bh'
              }
             this.setCountry(country)
        }
      },
    showProfileSidebar() {
      this.profileSidebar = true;
    },
     hideProfileSidebar() {
      console.log("Hello");
      this.profileSidebar = false;
    },
    // fbFirebaseSignIn() {
    //   let provider = new firebase.auth.FacebookAuthProvider();
    //   firebase
    //     .auth()
    //     .signInWithPopup(provider)
    //     .then((result) => {
    //       console.log({ result });
    //       let user = result.user;
    //       this.showLoading();
    //       let payload_test = {
    //         TokenFrom: "Google",
    //         stoken:
    //           "eyJhbGciOiJSUzI1NiIsImtpZCI6IjZmOGUxY2IxNTY0MTQ2M2M2ZGYwZjMzMzk0YjAzYzkyZmNjODg5YWMiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoiTXVzaGFoZWVlZCBTeWVkIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hLS9BT2gxNEdoTXdDdjk2S2lEN2FJX0FScTJhcTQzNHhVQTN4OGo2U0Z5V0Z2cHZhND1zOTYtYyIsImlzcyI6Imh0dHBzOi8vc2VjdXJldG9rZW4uZ29vZ2xlLmNvbS93YW5hc2F0aW1lLTkxYWM1IiwiYXVkIjoid2FuYXNhdGltZS05MWFjNSIsImF1dGhfdGltZSI6MTY1Mzk3OTQ3MywidXNlcl9pZCI6IjEydnVVN3QwWE1oZTBZMHg0TVR4TFhwM3lsRTMiLCJzdWIiOiIxMnZ1VTd0MFhNaGUwWTB4NE1UeExYcDN5bEUzIiwiaWF0IjoxNjUzOTc5NDczLCJleHAiOjE2NTM5ODMwNzMsImVtYWlsIjoic211c2hhaGVlZEBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJnb29nbGUuY29tIjpbIjExODE4NDIwMDYxNTA5MzQzMzE2MCJdLCJlbWFpbCI6WyJzbXVzaGFoZWVkQGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6Imdvb2dsZS5jb20ifX0.f5UhlYf8JmgdsIgm-LpP0v2ThtuT_raZ9T1jVArhCMmCSCWjzY0g5XgddWHc-ipcAJk0UB-wA5kNIlWDmqSHkVfF3ee6a-i-IEvr44Bsc5qv5T-PAA8GnkeG7S4Go21jgeqS6Y-x6ZNx2TlCHNZDMdcNmhrabK81lCa1T-RcKTYmA23_QZleY78gVXimJHDMOlHNdNRbkuYPDPrQlVQUGLjLmptaidGoqjjP2IH9iY-O6bm7qZVUDZLMlfCjuNMkt8sxupvykbuvdexDCRiGhDBTjM2_W5mReZkYmma3pwqnDu9KymxOAd-HMrs4cJTTIBWEVrQ0sVKKb9dMq-jrkA",
    //         Mobile: "0",
    //         CountryCode: "0",
    //         is_num: false,
    //         ReferralCode: "",
    //         ReferredBy: "",
    //         Origin: "https://www.mytiketi.com",
    //         FireBaseID:
    //           "e-9enrXyScGtjZgH2NSrH5:APA91bFfFSFGiL9ub7MXJ7c1ARAFkOfTvoNRMbnN6lCDXSL1C9Sv-kGVdrlmTk6rMYCa7lGN9ijoT20E7JNrPDGz8GLsmL8-UXqcbr9kXsXyz5-1XrbN9f9sH54IGlqzQd9civeYbw3i",
    //         CountryID: 112,
    //         LanguageID: 1,
    //         Latitude: 19.1387165,
    //         Longitude: 72.8312577,
    //       };
    //       let payload = {
    //         FireBaseID: "",
    //         TokenFrom: "Facebook",
    //         stoken:
    //           user.toJSON().stsTokenManager.accessToken ||
    //           result.credential.idToken,
    //         ReferredBy: this.referralCode,
    //       };
    //       // const profile = googleUser.getBasicProfile()
    //       return makeRequest(`/SocialLogin`, "POST", null, payload)
    //         .then((result) => {
    //           console.log({ result });
    //           this.hideLoading();
    //           TokenService.saveToken(result.res.data.access_token);
    //           this.hideSignIn();
    //           this.hideSignUp();
    //           this.loggedInFlag = true;
    //           this.loginUser(result.res.data.access_token);
    //           this.loggedInFlag = true;
    //         })
    //         .catch((error) => {
    //           console.log("Google Login Error", error);
    //           this.socialLoginError.error = "Something went wrong!";
    //           setTimeout(() => {
    //             this.socialLoginError.error = "";
    //           }, 5000);
    //         });
    //     })
    //     .catch((err) => {
    //       console.log(err); // This will give you all the information needed to further debug any errors
    //     });
    // },
    // googleFirebaseSignIn() {
    //   let provider = new firebase.auth.GoogleAuthProvider();
    //   firebase
    //     .auth()
    //     .signInWithPopup(provider)
    //     .then((result) => {
    //       console.log({ result });
    //       let user = result.user;
    //       this.showLoading();
    //       let payload_test = {
    //         TokenFrom: "Google",
    //         stoken:
    //           "eyJhbGciOiJSUzI1NiIsImtpZCI6IjZmOGUxY2IxNTY0MTQ2M2M2ZGYwZjMzMzk0YjAzYzkyZmNjODg5YWMiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoiTXVzaGFoZWVlZCBTeWVkIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hLS9BT2gxNEdoTXdDdjk2S2lEN2FJX0FScTJhcTQzNHhVQTN4OGo2U0Z5V0Z2cHZhND1zOTYtYyIsImlzcyI6Imh0dHBzOi8vc2VjdXJldG9rZW4uZ29vZ2xlLmNvbS93YW5hc2F0aW1lLTkxYWM1IiwiYXVkIjoid2FuYXNhdGltZS05MWFjNSIsImF1dGhfdGltZSI6MTY1Mzk3OTQ3MywidXNlcl9pZCI6IjEydnVVN3QwWE1oZTBZMHg0TVR4TFhwM3lsRTMiLCJzdWIiOiIxMnZ1VTd0MFhNaGUwWTB4NE1UeExYcDN5bEUzIiwiaWF0IjoxNjUzOTc5NDczLCJleHAiOjE2NTM5ODMwNzMsImVtYWlsIjoic211c2hhaGVlZEBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJnb29nbGUuY29tIjpbIjExODE4NDIwMDYxNTA5MzQzMzE2MCJdLCJlbWFpbCI6WyJzbXVzaGFoZWVkQGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6Imdvb2dsZS5jb20ifX0.f5UhlYf8JmgdsIgm-LpP0v2ThtuT_raZ9T1jVArhCMmCSCWjzY0g5XgddWHc-ipcAJk0UB-wA5kNIlWDmqSHkVfF3ee6a-i-IEvr44Bsc5qv5T-PAA8GnkeG7S4Go21jgeqS6Y-x6ZNx2TlCHNZDMdcNmhrabK81lCa1T-RcKTYmA23_QZleY78gVXimJHDMOlHNdNRbkuYPDPrQlVQUGLjLmptaidGoqjjP2IH9iY-O6bm7qZVUDZLMlfCjuNMkt8sxupvykbuvdexDCRiGhDBTjM2_W5mReZkYmma3pwqnDu9KymxOAd-HMrs4cJTTIBWEVrQ0sVKKb9dMq-jrkA",
    //         Mobile: "0",
    //         CountryCode: "0",
    //         is_num: false,
    //         ReferralCode: "",
    //         ReferredBy: "",
    //         Origin: "https://www.mytiketi.com",
    //         FireBaseID:
    //           "e-9enrXyScGtjZgH2NSrH5:APA91bFfFSFGiL9ub7MXJ7c1ARAFkOfTvoNRMbnN6lCDXSL1C9Sv-kGVdrlmTk6rMYCa7lGN9ijoT20E7JNrPDGz8GLsmL8-UXqcbr9kXsXyz5-1XrbN9f9sH54IGlqzQd9civeYbw3i",
    //         CountryID: 112,
    //         LanguageID: 1,
    //         Latitude: 19.1387165,
    //         Longitude: 72.8312577,
    //       };
    //       let payload = {
    //         FireBaseID: "",
    //         TokenFrom: "Google",
    //         stoken:
    //           user.toJSON().stsTokenManager.accessToken ||
    //           result.credential.idToken,
    //         ReferredBy: this.referralCode,
    //       };
    //       // const profile = googleUser.getBasicProfile()
    //       return makeRequest(`/SocialLogin`, "POST", null, payload)
    //         .then((result) => {
    //           console.log({ result });
    //           this.hideLoading();
    //           TokenService.saveToken(result.res.data.access_token);
    //           this.hideSignIn();
    //           this.hideSignUp();
    //           this.loggedInFlag = true;
    //           this.loginUser(result.res.data.access_token);
    //           this.loggedInFlag = true;
    //         })
    //         .catch((error) => {
    //           console.log("Google Login Error", error);
    //           this.socialLoginError.error = "Something went wrong!";
    //           setTimeout(() => {
    //             this.socialLoginError.error = "";
    //           }, 5000);
    //         });
    //     })
    //     .catch((err) => {
    //       console.log(err); // This will give you all the information needed to further debug any errors
    //     });
    // },
    onShowModal() {
      this.project == "myticketi"
        ? this.$root.$emit("bv::show::modal", "countryModalRef")
        : undefined;
    },
    navbarMenu($route_path, menu_path) {
      // console.log($route_path,menu_path);
      return (
        String($route_path).toLowerCase() == String(menu_path).toLowerCase()
      );
    },
    strongPassword: function () {},
    checkPassword: function (password) {
      let self = this;
      if (
        password != "" &&
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(
          password
        )
      ) {
        self.passwordBool = false;
      } else {
        self.passwordBool = true;
      }
    },
    // getAllCountry: function(country) {
    //   let countryData = CountryService.getCountry();
    //   makeRequest("/GetCountryList", "POST", null, {})
    //     .then(response => {
    //       const { error, res } = response;

    //       if (!error && res.data.Status) {
    //         this.countries = res.data.List;
    //         // if (countryData == null && this.countries.length > 1) {
    //         // console.log('this.countries header :', this.countries);
    //         //   this.$root.$emit("bv::show::modal", "countryModalRef");
    //         // }
    //         // else if (this.countries.length == 1) {
    //         //   this.countries.map(x => {
    //         //     if (x.CountryID == "230" || x.CountryID == "112") {
    //         //       countryData = x;
    //         //       this.countrySelected = x.CountryName;
    //         //       EventBus.$emit("selectedCountry", this.countrySelected);
    //         //       this.getNowShowingData();
    //         //       this.getAllFilters();
    //         //     }
    //         //     CountryService.saveCountry(countryData);
    //         //   });
    //         // } else {
    //         //   this.getNowShowingData();
    //         //   this.getAllFilters();
    //         // }
    //       }
    //     })
    //     .catch(error => {
    //       console.log("Error", error);
    //       //   resolve(null);
    //     });
    // },
    getGeoLocation: function () {
      if (navigator.geolocation) {
        //navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        x.innerHTML = "Geolocation is not supported by this browser.";
      }

      function showPosition(position) {
        let _position = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        window.localStorage.setItem("Geolocation", JSON.stringify(_position));
      }
    },
    onShowCurrentModal: function (ref) {
      console.log("ref :", ref);
      this.$refs[ref].show();
    },
    onCloseCurrentModal: function (ref) {
      this.$refs[ref].hide();
    },
    onCloseModal: function () {
      this.$refs.shareModal.hide();
    },
    onfbshare() {
      console.log("onfbshareonfbshareonfbshareonfbshare");
      window.open(
        "fb-messenger://share?link=" +
          encodeURIComponent(this.messageCopy) +
          "&app_id=" +
          encodeURIComponent("304861010210706")
      );
    },
    onCopy: function (e) {
      this.messageCopy = e.text;
      console.log("e.text :", e.text);
      this.$toasted.show("Link copied to clipboard");
      setTimeout(() => {
        this.$toasted.clear();
      }, 3000);
    },
    onsharefriend: function () {
      console.log("onsharefriend");
      this.$root.$emit("bv::show::modal", "shareModal");
    },
    onClickLogo: function () {
      // this.getAllCountry();

      this.$router.push({ name: "Home" });
      // EventBus.$emit("onClickLogo");
    },
    onClickHome: function () {
      // this.getAllCountry();
      this.$router.push({ name: "Home" });
    },
    getAllGetCountryList: function () {
      makeRequest("/GetCountryCode", "POST", null, {})
        .then((response) => {
          const { error, res } = response;
          if (res.data.Status) {
            this.CountryCodeList = res.data.List;
            this.DefaultCountryCode =
              res.data.Default.CountryCode || res.data.List.length
                ? res.data.List[0].CountryISOCode
                : "";
          }
          // console.log("Log", res.data.Default.CountryCode);
        })
        .catch((error) => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    onFocusOut() {
      setTimeout(() => {
        this.movieListSearch = [];
        this.cinemaListSearch = [];
      }, 500);
    },
    // api/dashuser/GetContentLang/
    onChangeLanguage: function (lang) {
      let language = {
        iso_2: lang.ISOCode,
        name: lang.LanguageName,
        lang: lang.ISOCode,
        lang_id: lang.LanguageID,
      };
      LanguageService.saveLanguage(language);
      this.$store.commit("SET_CURRENT_LANGUAGE", language);
      setI18nLanguage(lang.ISOCode.toLowerCase());
      this.selectedLang = lang.ISOCode ? lang.ISOCode.toLowerCase() : "en";
    },
    hideCountryModal: function () {
      EventBus.$emit("onClickLogo");
      this.$refs.countryModalRef.hide();
    },
    fetchLanguageData: function () {
      makeRequest(`/GetContentLang`, "POST", null, null)
        .then((result) => {
          this.languageData = result.res.data.List;
          // this.languageData = this.languageData.filter(x => {
          //   return x.ISOCode == "en";
          // });
          console.log(this.languageData, "sdfsdfsdfds");
        })
        .catch((error) => {
          console.log(" Error", error);
        });
    },
    fetchUserDetails: function () {
      let token = TokenService.getToken();
      if (token) {
        makeRequest(`/GetProfile`, "POST", token, null)
          .then((result) => {
            this.myUserDetails = result.res.data;
           
            EventBus.$emit("UserLoggedIn", this.myUserDetails);
            this.isUserLoggedIn = true;
            console.log("profile dara", this.myUserDetails.ReferalCodeURL);
            if (
              this.project == "myticketi" &&
              this.referralCode != "" &&
              this.showBonusPopup
            ) {
              console.log("project:", this.project);
              console.log("this.referralCode :", this.referralCode);
              this.onShowCurrentModal("registerbonusoffer");
            }
            if (this.myUserDetails.FirstName == "") {
              this.myUserDetails.displayName =
                this.myUserDetails.Email.split("@")[0];
            } else {
              this.myUserDetails.displayName = this.myUserDetails.FirstName;
            }
            this.messageCopy = this.myUserDetails.ReferalCodeURL;
          })
          .catch((error) => {
            console.log(" Error", error);
          });
      }
    },
    onChangeCountry: function (event) {
      console.log(event);
      if(event.isValid) {
        this.checkPhoneValid = true;
        this.userDetails.phoneNumber = event.phoneNumber;
      } else {
        this.checkPhoneValid = false;
      }
      this.userDetails.countryCode = event.countryCallingCode;
      // this.DefaultCountryCode = event.countryCallingCode;
    },
    saveLangToken: function (lang) {
      LanguageService.saveLanguage(lang);
      window.location.reload();
    },
    searchData: function () {
      if (this.searchValue.length > 0) {
        this.searchAPI();
        // } else if (this.searchValue.length == 0) {
        //   this.movieListSearch = [];
        //   this.cinemaListSearch = [];
      } else {
        this.movieListSearch = [];
        this.cinemaListSearch = [];
      }
    },
    onSelectQuery: function (query) {
      this.selectedQuery = query;
    },
    searchAPI: function () {
      let payload = {
        term: this.searchValue,
      };
      makeRequest(`/Search`, "POST", null, payload)
        .then((result) => {
          this.movieListSearch = result.res.data.Movies;
          this.cinemaListSearch = result.res.data.Cinema;
        })
        .catch((error) => {
          console.log("Google Login Error", error);
        });
    },

    showForgotPassword: function () {
      this.hideSignIn();
      this.$refs.forgotPassword.show();
      this.modal.forgotPassword.info = true;
    },
    hideForgotPassword: function () {
      // this.userDetails = {};

      this.$refs.forgotPassword.hide();
      this.modal.forgotPassword.info = true;
      this.modal.forgotPassword.OTP = false;
      this.modal.forgotPassword.resetPassword = false;
    },

    hideSignIn: function () {
      //
      this.userDetails.signinmodel = null;
      this.userDetails.password = null;
      this.$refs.signInModal.hide();
      this.resErrorMessage.signInError = "";
      this.errors.clear("signIn");
      this.$validator.reset();
      this.modal.signIn.OTP = false;
      this.modal.signIn.info = true;
    },
    hideSignUp: function () {
      this.userDetails = {};
      this.$refs.signUpModal.hide();
      this.errors.clear("signUp");
      this.$validator.reset();
      this.resErrorMessage.signUpError = "";
      this.modal.signUp.OTP = false;
      this.modal.signUp.info = true;
    },
    validateBeforeSubmit(scope) {
      if (scope == "signIn") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.showLoading();
            let emailreg =
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let bool = emailreg.test(this.userDetails.signinmodel);
            let payload = {};
            if (!bool) {
              payload = {
                Email: "",
                Mobile: this.userDetails.signinmodel,
                CountryCode: this.userDetails.countryCode || "91",
                Password: this.userDetails.password,
              };
            } else {
              this.userDetails.email = this.userDetails.signinmodel;
              payload = {
                Email: this.userDetails.signinmodel,
                Mobile: "0",
                CountryCode: this.userDetails.countryCode || "91",
                Password: this.userDetails.password,
              };
            }
            makeRequest("/Login", "POST", null, payload)
              .then((response) => {
                this.hideLoading();
                const { error, res } = response;
                
                if (res.data.Status) {
                  TokenService.saveToken(res.data.access_token);
                  // firebase
                  //   .auth()
                  //   .signInWithEmailAndPassword(
                  //     this.userDetails.signinmodel,
                  //     this.userDetails.password
                  //   )
                  //   .then(
                  //     user => {
                  //       alert("well done you are connected");
                  //     },
                  //     err => {
                  //       alert("Oops. " + err.message);
                  //     }
                  //   );
                  this.hideSignIn();
                  this.hideSignUp();
                  this.loggedInFlag = true;
                  if(!res.data.verifymobile) {
                  this.modal.signIn.OTP = true;
                  this.modal.signIn.info = false;
                }
                  this.fetchUserDetails();
                  this.loginUser(res.data.access_token);
                } else {
                  this.resErrorMessage.signInError = res.data.Message;
                }
              })
              .catch((error) => {
                this.resErrorMessage.signInError = "Something went wrong";
                console.log("Error", error);
                //   resolve(null);
              });
            // alert("Form Submitted!");
            return;
          }
        });
      }
      if (scope == "contactUs") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            let payload = {
              Name: this.contactUsDetails.name,
              Email: this.contactUsDetails.email,
              Phone: this.contactUsDetails.mobile,
              Message: this.contactUsDetails.message,
              Query: this.selectedQuery,
            };
            makeRequest("/ContactUs", "POST", null, payload)
              .then((response) => {
                const { error, res } = response;
                if (res.data.Status) {
                  this.contactUsDetails.errorMessage = res.data.Message;
                  setTimeout(() => {
                    this.$refs.support.hide();
                  }, 2000);
                } else {
                  this.contactUsDetails.errorMessage = res.data.Message;
                }
              })
              .catch((error) => {
                this.contactUsDetails.errorMessage = "Something went wrong";
              });
          }
        });
      }
      if (scope == "forgotPassword") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.showLoading();
            let emailreg =
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let bool = emailreg.test(this.userDetails.signinmodel);
            let payload = {};
            if (!bool) {
              payload = {
                Email: "",
                Mobile: this.userDetails.signinmodel,
                CountryCode: this.userDetails.countryCode || "91",
                VerifyMe: true,
              };
            } else {
              this.userDetails.email = this.userDetails.signinmodel;
              payload = {
                Email: this.userDetails.signinmodel,
                Mobile: "0",
                CountryCode: this.userDetails.countryCode || "91",
                VerifyMe: true,
              };
            }
           
            makeRequest("/Register", "POST", null, payload)
              .then((response) => {
                this.hideLoading();
                const { error, res } = response;
                if (res.data.Status) {
                  this.modal.forgotPassword.info = false;
                  this.modal.forgotPassword.OTP = true;
                } else {
                  this.resErrorMessage.signInError = res.data.Message;
                }
              })
              .catch((error) => {
                this.resErrorMessage.signInError = "Something went wrong";
                console.log("Error", error);
              });
            // alert("Form Submitted!");
            return;
          }
        });
      }
      if (scope == "signUp") {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.verifyMe = false;
            this.registerApi();
            // alert("Form Submitted!");
            return;
          }
        });
      }
      if (scope == "signInVerifyOTP") {
        this.verifyUser();
      }
      if (scope == "signUpVerifyOTP") {
        this.verifyUserSignUp();
      }
      if (scope == "forgotPasswordOTP") {
        this.verifyForgotPassword();
      }
      if (scope == "updateProfile") {
        // let token = TokenService.getToken();
        let token = this.tempToken ? this.tempToken : TokenService.getToken();
        console.log("Forgot Password token", token);
        let payload = {
          FirstName: this.userDetails.FirstName,
          LastName: this.userDetails.LastName,
          CountryCode: this.userDetails.CountryCode,
          Mobile: this.userDetails.Mobile,
          Gender: this.selected,
          Email: this.userDetails.Email,
          Password: this.userDetails.NewPassword,
          RePassword: this.userDetails.repassword,
        };
        makeRequest(`/UpdateProfile`, "POST", token, payload)
          .then((result) => {
            if (result.res.data.Status) {
              this.tempToken ? TokenService.saveToken(this.tempToken) : "";

              this.$refs.forgotPassword.hide();
              this.modal.forgotPassword.info = true;
              this.modal.forgotPassword.OTP = false;
              this.modal.forgotPassword.resetPassword = false;
            } else {
              this.resErrorMessage.otpError = result.res.data.Message;
            }
          })
          .catch((error) => {
            console.log(" Error", error);
          });
      }
    },
    registerApi: function () {
      // this.showLoading();

      let payload = {};
      if(!this.checkPhoneValid) {
        this.$toasted.show("Invalid Mobile Number");
        setTimeout(() => {
          this.$toasted.clear();
        }, 5000);
        return false;
      }  else {
        payload = {
        FullName: this.userDetails.fullName,
        Email: this.userDetails.email,
        Mobile: this.userDetails.phoneNumber || "0",
        Password: this.userDetails.password,
        RePassword: this.userDetails.password,
        Gender: this.selected,
        CountryCode: this.userDetails.countryCode || "91",
        ReferredBy: this.referralCode,
        VerifyMe: this.verifyMe,
        Password: this.userDetails.password,
        RePassword: this.userDetails.password,
      };

      makeRequest("/Register", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          this.hideLoading();
          if (res.data.Status) {
            this.modal.signUp.info = false;
            this.modal.signUp.OTP = true;
          } else {
            this.verifyMe = !res.data.verifyemail || !res.data.verifymobile;
            this.resErrorMessage.signUpError = res.data.Message;
          }
        })
        .catch((error) => {
          this.resErrorMessage.signUpError = error;
          console.log("Error", error);
          //   resolve(null);
        });
      }
    
    },

    verifyForgotPassword: function () {
      let payload = {
        Email: this.userDetails.email,
        Mobile: this.userDetails.phoneNumber || "0",
        CountryCode: "91",
        OTP: this.userDetails.OTP,
        FirebaseToken:
          "dSGHl9k_3eI:APA91bGmRzVggwlGr5pUISlD9f73uuCiysoEOG4GakPyXHmswjPlYZmY83tx1aPlH0W-5HTCsUCUYgIyfUzn0NX-wzv7LelazjLhuC46ASl2ySZdUQDYAyZOUjlKqLpDNqyiFRqtQSmZ",
        FromDevice: "IOS",
        DeviceModel: "iPhone X",
      };

      console.log("Verify OTP Payload", payload);

      makeRequest("/VerifyUser", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          console.log(res);
          if (res.data.Status) {
            this.modal.forgotPassword.OTP = false;
            this.modal.forgotPassword.resetPassword = true;
            // TokenService.saveToken(res.data.access_token);
            this.tempToken = res.data.access_token;
            this.fetchUserDetails();
          } else {
            this.resErrorMessage.Attempt = res.data.Attempt || false;
            this.resErrorMessage.otpError = res.data.Message;
          }
        })
        .catch((error) => {
          this.resErrorMessage.otpError = error;
          console.log("Error", error);
          //   resolve(null);
        });
    },

    verifyUserSignUp: function () {
      this.resErrorMessage.otpError = "";
      // let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // let bool = emailreg.test(this.userDetails.signinmodel);

      let payload = {
        Email: this.userDetails.email,
        Mobile: this.userDetails.phoneNumber || "0",
        CountryCode: "91",
        OTP: this.userDetails.OTP,
        FirebaseToken:
          "dSGHl9k_3eI:APA91bGmRzVggwlGr5pUISlD9f73uuCiysoEOG4GakPyXHmswjPlYZmY83tx1aPlH0W-5HTCsUCUYgIyfUzn0NX-wzv7LelazjLhuC46ASl2ySZdUQDYAyZOUjlKqLpDNqyiFRqtQSmZ",
        FromDevice: "IOS",
        DeviceModel: "iPhone X",
      };

      makeRequest("/VerifyUser", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          if (res.data.Status) {
            TokenService.saveToken(res.data.access_token);
            this.hideSignIn();
            this.hideSignUp();
            this.loggedInFlag = true;
            this.fetchUserDetails();
            this.loginUser(res.data.access_token);
            this.modal.signIn.info = true;
            this.modal.signIn.OTP = false;
            this.showBonusPopup = true;
          } else {
            this.resErrorMessage.Attempt = res.data.Attempt || false;
            this.resErrorMessage.otpError = res.data.Message;
          }
        })
        .catch((error) => {
          this.resErrorMessage.otpError = error;
          console.log("Error", error);
          //   resolve(null);
        });
      return;
    },
    verifyUser: function () {
      this.resErrorMessage.otpError = "";
      let emailreg =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let bool = emailreg.test(this.userDetails.signinmodel);

      let payload = {
        Email: this.userDetails.signinmodel,
        Mobile: this.userDetails.signinmodel || "0",
        CountryCode: this.userDetails.countryCode || "91",
        OTP: this.userDetails.OTP,
        FirebaseToken:
          "dSGHl9k_3eI:APA91bGmRzVggwlGr5pUISlD9f73uuCiysoEOG4GakPyXHmswjPlYZmY83tx1aPlH0W-5HTCsUCUYgIyfUzn0NX-wzv7LelazjLhuC46ASl2ySZdUQDYAyZOUjlKqLpDNqyiFRqtQSmZ",
        FromDevice: "IOS",
        DeviceModel: "iPhone X",
      };
      if (!bool) {
        payload.Email = "";
      }
      makeRequest("/VerifyUser", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          if (res.data.Status) {
            TokenService.saveToken(res.data.access_token);
            this.hideSignIn();
            this.hideSignUp();
            this.loggedInFlag = true;
            this.fetchUserDetails();
            this.loginUser(res.data.access_token);
            this.modal.signIn.info = true;
            this.modal.signIn.OTP = false;
          } else {
            this.resErrorMessage.otpError = res.data.Message;
          }
        })
        .catch((error) => {
          this.resErrorMessage.otpError = error;
          console.log("Error", error);
          //   resolve(null);
        });
      return;
    },
    loginUser: function (token) {
      if (token) {
        makeRequest("/GetProfile", "POST", token, null)
          .then((result) => {
            const { error, res } = result;
            if (!error && res.status) {
              this.myUserDetails = res.data;
              EventBus.$emit("UserLoggedIn", this.myUserDetails);
              EventBus.$emit("onProfileSuccess");

              if (
                this.project == "myticketi" &&
                this.referralCode != "" &&
                this.showBonusPopup
              ) {
                console.log("this.referralCode :", this.referralCode);
                this.onShowCurrentModal("registerbonusoffer");
              }
              if (this.myUserDetails.FirstName === "") {
                this.myUserDetails.displayName =
                  this.myUserDetails.Email.split("@")[0];
              } else {
                this.myUserDetails.displayName = this.myUserDetails.FirstName;
              }
            } else {
              console.log("error from res", res.message);
            }
          })
          .catch((error) => {
            console.log("Error on vue front", error);
          });
      }
    },
    getAllCountry: function (country) {
      // let countryData = CountryService.getCountry();
      // console.log("country from db", countryData);
      // if(countryData)
      // this.DefaultCountryCode = countryData.CountryISOCode || '';
      makeRequest("/GetCountryList", "POST", null, {})
        .then((response) => {
          const { error, res } = response;
          // first time with no data
          // if (window.location.origin == "https://uae.ticketak.com") {
          //   CountryService.saveCountry(res.data.List[1]);
          //   // window.location.reload();

          //   this.$refs.countryModalRef.hide();

          //   //
          // } else if (window.location.origin == "https://kw.ticketak.com") {
          //   CountryService.saveCountry(res.data.List[0]);
          //   // window.location.reload();
          //   this.$refs.countryModalRef.hide();

          //   //
          // } else if (countryData == null) {
          //   if (res.data.Default.CountryISOCode == "UAE") {
          //     window.location.replace("https://uae.ticketak.com");
          //     CountryService.saveCountry(res.data.List[1]);
          //     this.$refs.countryModalRef.hide();

          //     // window.location.reload();
          //   } else if (res.data.Default.CountryISOCode == "KW") {
          //     window.location.replace("https://kw.ticketak.com");
          //     CountryService.saveCountry(res.data.List[0]);
          //     this.$refs.countryModalRef.hide();
          //     // window.location.reload();
          //   } else {
          //     this.$refs.countryModalRef.show();
          //   }
          // }
          // // with UAE
          // else if (
          //   res.data.Default.CountryISOCode == "KW" &&
          //   countryData.CountryName == "UAE"
          // ) {
          //   window.location.replace("https://uae.ticketak.com");
          // } //with KW
          // else if (
          //   res.data.Default.CountryISOCode == "UAE" &&
          //   countryData.CountryName == "Kuwait"
          // ) {
          //   window.location.replace("https://kw.ticketak.com");
          // } else if (
          //   window.location.origin == "https://kw.ticketak.com" &&
          //   res.data.Default.CountryISOCode == "UAE" &&
          //   countryData.CountryName == "UAE"
          // ) {
          //   window.location.replace("https://kw.ticketak.com");
          // } else if (
          //   window.location.origin == "https://uae.ticketak.com" &&
          //   res.data.Default.CountryISOCode == "KW" &&
          //   countryData.CountryName == "KW"
          // ) {
          //   window.location.replace("https://uae.ticketak.com");
          // }

          if (!error && res.data.Status) {
            // if (countryData == null) {
            //   if (res.data.Default.CountryID === 0) {
            //     CountryService.saveCountry(res.data.Default);
            //   } else if (this.project == "ticketak") {
            //     //this.$refs.countryModalRef.show();
            //   }
            // } else {
            //   // this.redirectDomain(countryData.CountryName);
            // }

            this.countries = res.data.List;
            if (this.project == "ticketak") {
              this.countries.map((x) => {
                if (x.CountryID == "230" || x.CountryID == "112") {
                  countryData = x;
                  this.countrySelected = x.CountryName;
                }
                CountryService.saveCountry(countryData);
              });
            }
          }
        })
        .catch((error) => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    getAllCity: function (country) {
      makeRequest(
        "/app/getcitylist?countryId=" + this.countrySelected.ID,
        "POST",
        null,
        null
      )
        .then((response) => {
          const { error, res } = response;
          console.log("city", response);
          if (!error && res.data.Status) {
            this.city = res.data.Cities;
          }
        })
        .catch((error) => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    redirectDomain(country) {
      if (
        country == "UAE" &&
        window.location.origin != "https://uae.ticketak.com"
      ) {
        window.location.replace("https://uae.ticketak.com");
      }
      //kw
      else if (
        country == "Kuwait" &&
        window.location.origin != "https://kw.ticketak.com"
      ) {
        window.location.replace("https://kw.ticketak.com");
      }
    },
    setCountry: function (country, redirect) {
      CountryService.saveCountry(country);
      console.log(country);
      // this.countrySelected = country;
      this.countrySelected = country.CountryName;
      if (this.countrySelected == "Qatar") {
        window.location = "/events";
      } else {
        if(redirect == true){
         window.location = "/";
      }
      }
      // this.redirectDomain(this.countrySelected);
      
    },
    setCity: function (city) {
      this.$persistStore.set("city", JSON.stringify(city));
      window.location = "/";
    },
    theScroll: function () {
      if (window.scrollY >= 30) {
        this.onScroll = false;
      } else {
        this.onScroll = true;
      }
    },
    handleScroll: function () {
      var that = this;
      throttle(that.theScroll, 2000);
    },

    hideContactUs: function () {
      // window.location.href = "/";
      this.$refs.support.hide();
      this.contactUsDetails = {};
    },

    forgotPasswordOpenSend: function (section) {
      console.log("f");
      if (section == "step1") {
        this.forgotPasswordSection = 1;
      } else if (section == "step2") {
        let payload = {
          UserName: this.inputData.userName,
        };
        makeRequest("/api/Account/Forgot/", "POST", null, payload)
          .then((response) => {
            //   console.log("Country List Here >>>", response);
            const { error, res } = response;
            console.log("forgotpass1 response", response);
            if (!error && res.data.Status) {
              this.inputData.ReSetCode = res.data.ReSetCode;
              this.forgotPasswordSection = 2;
              // this.cities = res.data.Cities;
              // console.log("Country >>", this.country);
            }
          })
          .catch((error) => {
            console.log("Error", error);
            //   resolve(null);
          });
      } else {
        let payload = {
          ReSetCode: this.inputData.ReSetCode,
          Password: this.inputData.password,
          SecureCode: this.inputData.code,
        };
        makeRequest("/api/Account/ResetPassword/", "POST", null, payload)
          .then((response) => {
            //   console.log("Country List Here >>>", response);
            const { error, res } = response;
            console.log("forgotpass2 response", response);
            if (!error && res.data.Status) {
              this.forgotPasswordSection = 3;
              // this.cities = res.data.Cities;
              // console.log("Country >>", this.country);
            }
          })
          .catch((error) => {
            console.log("Error", error);
            //   resolve(null);
          });

        // this.forgotPasswordSection = 3;
      }
    },
    onGoogleSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users

      console.log("googleUser", googleUser);
      this.showLoading();
      const profile = googleUser.getBasicProfile();
      makeRequest(`/SocialLogin`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Google",
        stoken: googleUser.Zi ? googleUser.Zi.id_token : googleUser.wc.id_token,
        ReferredBy: this.referralCode,
      })
        .then((result) => {
          this.hideLoading();
          TokenService.saveToken(result.res.data.access_token);
          this.hideSignIn();
          this.hideSignUp();
          this.loggedInFlag = true;
          this.loginUser(result.res.data.access_token);
          this.loggedInFlag = true;
        })
        .catch((error) => {
          console.log("Google Login Error", error);
        });
    },
    onGoogleSignInError(error) {
      this.socialLoginError.error = "Something went wrong!";
      setTimeout(() => {
        this.socialLoginError.error = "";
      }, 5000);
    },
    onSignFBInSuccess(response) {
      makeRequest(`/SocialLogin`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Facebook",
        stoken: response.authResponse.accessToken,
        ReferredBy: this.referralCode,
      })
        .then((result) => {
          console.log("Check Socal Facebook response From here ", result);
          TokenService.saveToken(result.res.data.access_token);
          this.hideSignIn();
          this.hideSignUp();
          this.loggedInFlag = true;
          this.loginUser(result.res.data.access_token);
          //result has
        })
        .catch((error) => {
          console.log("Face book Login Error", error);
        });
      // Testing;
      FB.api("/me", (data) => {
        console.log("Facebook Data ", data);
      });
    },
    onSignFBInError(error) {
      this.socialLoginError.error = "Whoops, !Something went wrong";
      setTimeout(() => {
        this.socialLoginError.error = "";
      }, 5000);
    },

    showLoginModal: function () {
      this.loginDiv = true;
    },
    logOut: function () {
      this.loggedInFlag = false;
      this.$persistStore.remove("accessToken");

      makeRequest(`/api/Account/SocialLogin`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Google",
        stoken: googleUser.Zi.id_token,
      });
    },

    CheckLoginFun: function (data) {
      console.log("gmamamam", data);
    },

    openMobileSearch() {},

    handleMobileSearch() {
      console.log("Search Movies Here", this.mobileSearch);
      if (this.mobileSearch) {
        this.onSearchInputChange("");
        this.mobileSearch = false;
      } else {
        this.mobileSearch = true;
      }
    },

    onSearchItemSelected(item) {
      console.log("item", item);
      this.selectedSearchMovie = item;
      this.searchQuery = item && item.hasOwnProperty("Name") ? item.Name : "";

      let name = item.Name.replace(/\s/g, "-").toLowerCase();
      var payload = {
        categoryId: item.ShowCat,
        movieId: item.ID,
        movieName: item.Name,
      };
      // this.$store.dispatch("setMoviesDetails", payload);
      // this.$store.dispatch("setLeadItem", "FIFIFIFIF");
      //   localforage.setItem("NAMEME", "SAIF");
      this.$persistStore.set("GetMovieDetails", JSON.stringify(payload));
      //   this.$store.dispatch("setMoviesDetails", payload);
      // this.$router.push({
      //   path: "/movies",
      //   params: {}
      // });

      if (item.ShowCat == 4) {
        this.$router.push({
          path: "/create-movie-screen",
          params: {},
        });
      } else if (item.ShowCat == 2) {
        this.$router.push({
          path: "/special-movie-screen",
          params: {},
        });
      } else if (item.ShowCat == 1) {
        this.$router.push({
          path: "/movie-details",
          params: {},
        });
      } else if (item.ShowCat == 3) {
        this.$router.push({
          path: "/movie-details",
          params: {},
        });
      }
    },
    handlerOtpFocus: function () {
      // v-on:focus.native="handlerOtpFocus()"
      console.log("inside the focus");
      this.otpDetails.otpError.message = "";
    },
    handlerOtpValidation: function (id) {
      this.otpDetails.otpError.message = "";

      if (id == "first") {
        this.otpDetails.otpInputs.first = this.otpDetails.otpInputs.first.slice(
          0,
          1
        );
      } else if (id == "second") {
        this.otpDetails.otpInputs.second =
          this.otpDetails.otpInputs.second.slice(0, 1);
      } else if (id == "third") {
        this.otpDetails.otpInputs.third = this.otpDetails.otpInputs.third.slice(
          0,
          1
        );
      } else if (id == "fourth") {
        this.otpDetails.otpInputs.fourth =
          this.otpDetails.otpInputs.fourth.slice(0, 1);
      }
      this.otpDetails.status.buttonFlag =
        Object.keys(this.otpDetails.otpInputs).filter(
          (x) => this.otpDetails.otpInputs[x] !== ""
        ).length == 4
          ? false
          : true;
    },
    backBrowsing: function (id) {
      console.log("id", id);
      $(id).modal("toggle");
      this.$router.push({
        path: "/",
        params: {},
      });
    },
    // Social Login Start
    onGoogleSignIn(id) {
      //call-Google-Auth
      console.log("Google Call", id);
    },
    onGoogleSuccess(success) {
      console.log("on Success >>", success);
      // this.$persistStore.set("accessToken", data.result.access_token);
      //     this.loggedInFlag = true;
      //     window.location = "/";
    },
    onGoogleFailure(fail) {
      console.log("on Failure google", fail);
    },

    // social facebook
    onFacebookLogin: function () {
      console.log(">>>>> social login");
      //   makeRequest("/app/social-signin", "POST", null)
      //     .then(response => {
      //       const { error, res } = response;
      //       const { data } = res.data;
      //       console.log("checking social-signin");
      //     })
      //     .catch(error => {
      //       console.log("Error", error);
      //       //   resolve(null);
      //     });
    },

    // LOGIN PROCESS

    onLogout() {
      // let token = TokenService.getToken();
      // makeRequest("/AccountLogout", token, null)
      //   .then(result => {
      //     const { data } = result;
      //     if (data.Status) {
      window.localStorage.removeItem("access_token");
      TokenService.removeToken();
      window.location.reload();
      window.location.pathname = "/";
      this.loggedInFlag = false;
      // }
      //   console.log("result :", result);
      // })
      // .catch(err => {});
    },

    handlerLoginValidation: function (name, flag) {
      this.resErrorMessage.signInError = "";
      //   console.log(
      //     "MMMMMMMM",
      //     this.emailReg.test(this.loginData.loginInput.email)
      //   );
      if (name == "email") {
        // this.errorMessage.email = "";
        this.loginData.errorMessage.email =
          this.loginData.loginInput.email == ""
            ? ""
            : this.emailReg.test(this.loginData.loginInput.email)
            ? ""
            : "error";
        this.loginData.errorMessageStatus.email = this.emailReg.test(
          this.loginData.loginInput.email
        );
      } else if (name == "password") {
        let passwordRege = /(?=.{4,})/;
        this.loginData.errorMessage.password =
          this.loginData.loginInput.password == ""
            ? ""
            : passwordRege.test(this.loginData.loginInput.password)
            ? ""
            : "error";
        this.loginData.errorMessageStatus.password = passwordRege.test(
          this.loginData.loginInput.password
        );
      } else if (name == "conditions") {
        this.loginData.errorMessage.conditions =
          this.loginData.loginInput.conditions;
        this.loginData.errorMessageStatus.conditions =
          this.loginData.loginInput.conditions;
      }
      this.checkButtonLoginStatus();
    },
    checkButtonLoginStatus() {
      //   console.log(
      //     this.loginData,
      //     "Here Login",
      //     this.loginData.button,
      //     Object.keys(this.loginData.errorMessageStatus).filter(
      //       x => this.loginData.errorMessageStatus[x] == true
      //     ).length
      //   );
      this.loginData.button =
        Object.keys(this.loginData.errorMessageStatus).filter(
          (x) => this.loginData.errorMessageStatus[x] == true
        ).length == 3
          ? false
          : true;
    },

    onSubmitLogin: function () {
      // this.resErrorMessage.signInError = "";
      //   console.log("here >>");
      let payload = {
        UserName: this.loginData.loginInput.email,
        Password: this.loginData.loginInput.password,
      };
      makeRequest("/api/signin", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          const { data } = res.data;
          if (!error && res.data.status && data.result.Status) {
            console.log("checking otp succ", data);
            this.showSeatNoModal("#signin-page");
            // this.$cookies.set("access_token", data.result.access_token, "1d");

            this.userName = data.result.UserName;
            // this.loggedFlag = true;
            EventBus.$emit("UserLogged", {
              status: true,
              userName: data.result.UserName,
            });
            // userLoggedIn();
          } else {
            // console.log("Error in reuqst ", data.result.Message);
            // this.otpDetails.otpError.message = data.result.Message;
            // setTimeout(() => {
            //   this.otpDetails.otpError.message = "";
            // }, 5000);
          }
        })
        .catch((error) => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    userSignout() {
      this.$cookies.remove("access_token");
      // remove a cookie
      this.$cookies.remove("HUID");
      this.loggedFlag = false;
      this.userName = "";
    },
  },
  watch: {
    $route(to, from) {
      this.searchValue = "";
    },
    searchValue: function (newVal, oldVal) {
      console.log("val>>", newVal, oldVal);
    },
    "$route.query": {
      handler(newVal, oldVal) {
        console.log({ newVal: { ...newVal }, oldVal: { ...oldVal } });
        const is_mobile_app = parseInt(newVal.is_mobile_app) || 0;

        this.$nextTick(() => {
          if (!!is_mobile_app) {
            this.is_mobile_app = is_mobile_app;
          }
        });
      },
      immediate: true,
    },
  },
  updated: function () {
    // console.log("t", this.page);
    this.page = this.$route.path;
  },
  destroyed() {
    this.searchValue = "";
  },
};
</script>
<style>
.vue-tel-input {
  margin-bottom: 15px;
  border-radius: 8px;
  background-color: #fff;
  padding: 0.375rem 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/header.vue